import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/design.css'
import './assets/css/photoEdit_1280-1389.css'
import './assets/css/photoEdit_1390-1620.css'
import './assets/css/reset.min.css'
import './assets/css/photoEdit.css'
import './assets/css/photoEdit_767.css'
import './assets/css/builder.css'
import './components/Login.css'
import './components/RealtimeVideo.css'
import { Buffer } from 'buffer'
window.Buffer = Buffer
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
